// ── Application registry ──
// Each app has a nav gate (`requires` = a truthy flag on the user) and a default landing page.
import { B } from "../shared/theme";
import { MdAccountBalance, MdInventory, MdTrendingUp } from "react-icons/md";

export const APPS = [
  // Mirrors canAccessPortfolio() in api/shared/auth.js — the API refuses these
  // endpoints independently, so this only decides whether the tile is offered.
  // Narrow on purpose: the ONLY people excluded are sales-only users (isbdo or
  // isbdomanager and nothing else). A plain Standard User with no flags keeps
  // the access they have today.
  { id:"upm",        name:"Portfolio Management",  tag:"Portfolio Platform",  short:"PM", icon:MdAccountBalance, color:B.cyan,
    requires: (u) => {
      if (!u) return false;
      if (u.role === "Admin") return true;
      if (!(u.isbdo || u.isbdomanager)) return true;
      return !!(u.isportfoliomanager || u.isunderwriter || u.isservicer || u.isaccountmanager
                || u.istermfunding || u.isdrawfunding || u.isbankcredviewer);
    } },
  // A predicate rather than a flag name: Admins get in without needing
  // isportfoliomanager, matching how Sales and Portfolio already behave.
  // canAccessPortfolio() in api/shared/auth.js already returns true for Admin,
  // so the API was never the thing blocking them — only this tile was.
  { id:"collateral", name:"Collateral Management", tag:"Collateral Platform", short:"CM", icon:MdInventory,      color:"#7B3F8C",
    requires: (u) => !!(u && (u.isportfoliomanager || u.role === "Admin")) },
  // A predicate rather than a flag name: sales is open to BDOs, their managers,
  // and admins. `requires` still accepts a plain flag string for the other apps.
  { id:"sales",      name:"Sales",                 tag:"Sales Platform",      short:"SL", icon:MdTrendingUp,     color:"#1a7f4b",
    requires: (u) => !!(u && (u.isbdo || u.isbdomanager || u.role === "Admin")) },
];

// One place that decides whether a user may enter an app. `requires` may be a
// flag name, an array of flag names (any match), or a predicate.
export const appAllowed = (app, user) => {
  if (!app || !app.requires) return true;
  if (typeof app.requires === "function") return !!app.requires(user);
  const need = Array.isArray(app.requires) ? app.requires : [app.requires];
  return need.some(f => !!(user && user[f]));
};

export const DEFAULT_PAGE = { upm:"dashboard", collateral:"collateral-portfolio", sales:"sales-dashboard" };
